/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_PriceInputs */

const et_plan_best_price = /** @type {(inputs: Plan_Best_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€997 / Kvartal`)
};

const en_plan_best_price = /** @type {(inputs: Plan_Best_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€997 / Quarter`)
};

/**
* | output |
* | --- |
* | "€997 / Quarter" |
*
* @param {Plan_Best_PriceInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_price = /** @type {((inputs?: Plan_Best_PriceInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_PriceInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_price(inputs)
	return en_plan_best_price(inputs)
});